import { useEffect, useState } from "react";

import { decoColumns } from "./misc/deco-columns";
import useAxios from "@hooks/use-axios";
import useSearchParams from "@hooks/use-search-params";

const useUsers = () => {

    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });

    const { getSearchParams } = useSearchParams();
    const [data, setData] = useState({ users: [], pagination: {} });
    const [queryParams, setQueryParams] = useState({});
    const [modalConfig, setModalConfig] = useState({ isOpen: false, row: {} });

    const handleModalConfig = (row = {}) => {
        setModalConfig(prev => ({ row, isOpen: !prev.isOpen }));
    };
    const getUsers = async () => {

        // TODO: add pagination from BE
        const { data, pagination } = await axiosInstance.get("/user", {
            params: {
                page : getSearchParams("page"),
                limit: getSearchParams("limit")
            }
        });
        setData({
            users     : data || [],
            pagination: pagination || {}
        });
    };

    const handleRowActions = async (row, action) => {
        if (action === "delete") {
            await axiosInstance.delete(`/user/${row.id}`);
            getUsers();
            return;
        } 
        handleModalConfig(row);
    };

    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getUsers();
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    return {
        data,
        loading,
        columns: decoColumns({ handleRowActions }),
        getUsers,
        setQueryParams,
        handleModalConfig,
        modalConfig,
        isOpen : modalConfig.isOpen
    };
};

export default useUsers;
